const GRADES = 'Grades'
const SECTIONS = 'Sections'
const SESSION_STATUS = 'Session status'
const COURSE = 'Course'


export { GRADES, SECTIONS, SESSION_STATUS, COURSE }